/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import CheckDigiFlow from "./CheckDigiFlow.container";

export default CheckDigiFlow;
